<script>
   import { onMount, afterUpdate } from "svelte";
   import { gsap } from "gsap";
   import { ScrollTrigger } from "gsap/ScrollTrigger";
   gsap.registerPlugin(ScrollTrigger)

   export let category, posts = []
   // console.log(posts)

   onMount(() => {
      // console.log(category)
      // setTimeout(()=> {
      //    gsap.set('.news-section:not(.news-featured) .news-post', {y:20})
      //    gsap.to('.news-section:not(.news-featured) .news-post', {opacity: 1, y:0, duration: 0.35, ease: 'power1.out', stagger: 0.1})
      // }, 1200)
   })

</script>

<!-- Portfolio News -->
<div id="news-section" class="news-section">
   <div class="news-grid">
   {#each posts as post,_idx}
      <div class="news-post">
         <div class="new-post-image" style="background-image: url({post.img}})"></div>
         <div class="new-post-content">
            <h3>{post.post_title}</h3>
            <div class="row mx-0 justify-content-between">
               <time>{post.postdate}</time>
               <a href={"#"} class="external-link">Learn more</a>
            </div>
         </div>
      </div>
   {/each}
   </div>
   <!-- TODO rewrite -->
   {#if category & posts.length}
      <a href="/category/{category.slug}" class="btn outlined-btn btn-red mt-5">More {category.name}</a>
   {:else if !posts.length}
      <p>No Posts Found</p>
   {/if}
</div>